export const VIEWCALENDAR_FETCH_DATA = 'VIEWCALENDAR_FETCH_DATA';
export const VIEWCALENDAR_SLOT_ADD = 'VIEWCALENDAR_SLOT_ADD';
export const VIEWCALENDAR_SLOT_CLOSE_TOGGLE = 'VIEWCALENDAR_SLOT_CLOSE_TOGGLE';
export const VIEWCALENDAR_SLOT_BLOCKER_ADD = 'VIEWCALENDAR_SLOT_BLOCKER_ADD';

export const VIEWCALENDAR_SAVE_DATA = 'VIEWCALENDAR_SAVE_DATA';
